import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { motion } from "framer-motion";

export function CtaBand() {
    const navigate = useNavigate();
    return (
        <section
            className="relative overflow-hidden bg-gradient-to-br from-klareet-T via-klareet-T to-klareet-T2"
            data-testid="cta-band"
        >
            {/* faint diagonal pattern overlay */}
            <div
                className="absolute inset-0 opacity-[0.07] pointer-events-none"
                style={{
                    backgroundImage:
                        "linear-gradient(45deg, white 1px, transparent 1px)",
                    backgroundSize: "16px 16px",
                }}
                aria-hidden
            />
            <div className="relative max-w-6xl mx-auto px-6 sm:px-8 lg:px-12 py-16 md:py-20 text-center">
                <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-white">
                    Ready to be honest?
                </h2>
                <p className="mt-5 text-base md:text-lg text-white/90 max-w-xl mx-auto leading-relaxed">
                    Take the 4-minute survey. Get your glimpse. Help us build
                    a better version of career clarity.
                </p>
                <motion.button
                    type="button"
                    onClick={() => navigate("/survey")}
                    whileHover={{ y: -2 }}
                    whileTap={{ scale: 0.97 }}
                    className="mt-8 inline-flex items-center gap-2 px-7 py-4 rounded-full bg-white text-klareet-NAVY text-base font-semibold tracking-tight shadow-[0_15px_40px_-12px_rgba(0,0,0,0.45)] hover:bg-klareet-TEXT transition-colors"
                    data-testid="cta-band-btn"
                >
                    Start the survey
                    <ArrowRight size={18} />
                </motion.button>
            </div>
        </section>
    );
}
